import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAllSessions } from '../../../shared/utils/api.js'

export const fetchAllSessions = createAsyncThunk(
  'session/fetchAllSessions',
  async () => {
    const response = await getAllSessions()
    return response.data
  }
)